export default {
  Active: 'Active',
  Deleted: 'Deleted',
  Paused: 'UserPaused',
  Suspended: 'Suspended',

  // used in wunderbar, needs to be migrated once workflow goes to oData
  EnumPaused: 124,
  EnumBudgetPaused: 126,
  EnumBudgetUserPaused: 127,
};
